import { render, staticRenderFns } from "./Debtor.vue?vue&type=template&id=69edae5e&lang=pug&"
import script from "./Debtor.vue?vue&type=script&lang=ts&"
export * from "./Debtor.vue?vue&type=script&lang=ts&"
import style0 from "./Debtor.vue?vue&type=style&index=0&id=69edae5e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports